import {Component, Input} from '@angular/core';

import {Example} from '../../models/example.model';
import {VoiceService} from '../../services/voice/voice.service';

@Component({
  selector: 'app-example-play-btn',
  template: `
    <button type="button"
            *ngIf="show"
            class="sound-btn {{ on ? 'on' : '' }}"
            (click)="playSound($event)"></button>
  `,
  styleUrls: ['./example-play-btn.component.scss'],
})
export class ExamplePlayBtnComponent {
  @Input() example: Example | null = null;

  constructor(
    private voice: VoiceService,
  ) {
  }

  public playSound(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.example?.example_voice) {
      console.error('ExamplePlayBtnComponent::playSound() invalid example voice', this.example);
      return;
    }

    if (this.on) {
      this.voice.Stop();
    }
    else {
      this.voice.PlayExample(this.example.id, this.example.example_voice).subscribe();
    }
  }

  public get show(): boolean {
    return !!this.example?.example_voice;
  }

  public get on(): boolean {
    return this.voice.on && this.voice.exampleId === this.example?.id;
  }
}
